export const locale = {
  lang: "en",
  data: {
    BILLDATE: "Invoice Date",
    COSTS: "Costs",
  },
};
